/* global axios */
import ApiClient from "./ApiClient";

class BulkBroadcastsAPI extends ApiClient {
  constructor() {
    super("bulk_broadcasts", { accountScoped: true });
  }

  get({ page = 1, per = 25, filter = "all", inboxId, createdById } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        per,
        filter,
        inbox_id: inboxId,
        created_by_id: createdById,
      },
    });
  }

  getActive() {
    return axios.get(this.url, { params: { active: true } });
  }

  getRecipients(id, { page = 1, per = 50, status, q } = {}) {
    return axios.get(`${this.url}/${id}/recipients`, {
      params: { page, per, status, q },
    });
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  stop(id) {
    return axios.post(`${this.url}/${id}/stop`);
  }

  reschedule(id, scheduledAt) {
    return axios.patch(`${this.url}/${id}/reschedule`, {
      scheduled_at: scheduledAt,
    });
  }
}

export default new BulkBroadcastsAPI();
